import React from "react";
import "../Footer/Footer.css";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 d-grid">
              <div className="footer-menu">
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>

                  <li>
                    <a href="/about">About us</a>
                  </li>
                  <li>
                    <a href="/why-choose-us">Why Choose us</a>
                  </li>
                  <li>
                    <a href="/contact-us">Contact</a>
                  </li>
                </ul>
              </div>
              <div className="footer-social-media">
                <ul>
                  <li data-aos="fade-down" data-aos-delay="100">
                    <a
                      href="https://www.instagram.com/okcuptowncleaning/"
                      target="_blank"
                    >
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_626_36)">
                          <path
                            d="M12.4999 5.5C14.6509 5.5 14.9193 5.5075 15.7632 5.545C16.6063 5.5825 17.1803 5.70775 17.6853 5.89375C18.2078 6.08425 18.648 6.34225 19.0882 6.7585C19.4907 7.13342 19.8022 7.58694 20.001 8.0875C20.1965 8.56525 20.3295 9.10975 20.3691 9.9085C20.4063 10.708 20.4166 10.9622 20.4166 13C20.4166 15.0378 20.4087 15.292 20.3691 16.0915C20.3295 16.8903 20.1965 17.434 20.001 17.9125C19.8028 18.4133 19.4912 18.867 19.0882 19.2415C18.6923 19.6227 18.2136 19.9178 17.6853 20.1063C17.181 20.2915 16.6063 20.4175 15.7632 20.455C14.9193 20.4903 14.6509 20.5 12.4999 20.5C10.349 20.5 10.0806 20.4925 9.23667 20.455C8.39354 20.4175 7.81959 20.2915 7.3145 20.1063C6.78593 19.9184 6.30713 19.6232 5.91167 19.2415C5.50903 18.8666 5.19753 18.4131 4.99888 17.9125C4.80254 17.4347 4.67034 16.8903 4.63075 16.0915C4.59354 15.292 4.58325 15.0378 4.58325 13C4.58325 10.9622 4.59117 10.708 4.63075 9.9085C4.67034 9.109 4.80254 8.566 4.99888 8.0875C5.19698 7.58663 5.50855 7.13299 5.91167 6.7585C6.30724 6.37692 6.78601 6.0818 7.3145 5.89375C7.81959 5.70775 8.39275 5.5825 9.23667 5.545C10.0806 5.50975 10.349 5.5 12.4999 5.5ZM12.4999 9.25C11.4501 9.25 10.4433 9.64509 9.70095 10.3483C8.95862 11.0516 8.54159 12.0054 8.54158 13C8.54159 13.9946 8.95862 14.9484 9.70095 15.6517C10.4433 16.3549 11.4501 16.75 12.4999 16.75C13.5497 16.75 14.5566 16.3549 15.2989 15.6517C16.0412 14.9484 16.4583 13.9946 16.4583 13C16.4583 12.0054 16.0412 11.0516 15.2989 10.3483C14.5566 9.64509 13.5497 9.25 12.4999 9.25ZM17.6458 9.0625C17.6458 8.81386 17.5415 8.5754 17.3559 8.39959C17.1703 8.22377 16.9186 8.125 16.6562 8.125C16.3937 8.125 16.142 8.22377 15.9564 8.39959C15.7708 8.5754 15.6666 8.81386 15.6666 9.0625C15.6666 9.31114 15.7708 9.5496 15.9564 9.72541C16.142 9.90123 16.3937 10 16.6562 10C16.9186 10 17.1703 9.90123 17.3559 9.72541C17.5415 9.5496 17.6458 9.31114 17.6458 9.0625ZM12.4999 10.75C13.1298 10.75 13.7339 10.9871 14.1793 11.409C14.6247 11.831 14.8749 12.4033 14.8749 13C14.8749 13.5967 14.6247 14.169 14.1793 14.591C13.7339 15.0129 13.1298 15.25 12.4999 15.25C11.87 15.25 11.2659 15.0129 10.8205 14.591C10.3751 14.169 10.1249 13.5967 10.1249 13C10.1249 12.4033 10.3751 11.831 10.8205 11.409C11.2659 10.9871 11.87 10.75 12.4999 10.75Z"
                            fill="white"
                          />
                        </g>
                        <circle cx="13" cy="13" r="12.5" stroke="white" />
                        <defs>
                          <clipPath id="clip0_626_36">
                            <rect
                              width="19"
                              height="18"
                              fill="white"
                              transform="translate(3 4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li data-aos="fade-down" data-aos-delay="200">
                    <a
                      href="https://www.linkedin.com/company/okc-uptown-cleaning-llc/"
                      target="_blank"
                    >
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_41_189)">
                          <path
                            d="M12.9808 0.185547C5.821 0.185547 0 5.79096 0 12.6855C0 19.5801 5.821 25.1855 12.9808 25.1855C20.1405 25.1855 25.9615 19.5801 25.9615 12.6855C25.9615 5.79096 20.1405 0.185547 12.9808 0.185547ZM12.9808 24.2376C6.3657 24.2376 0.984386 19.0556 0.984386 12.6855C0.984386 6.31548 6.3657 1.13347 12.9808 1.13347C19.5958 1.13347 24.9772 6.31548 24.9772 12.6855C24.9772 19.0556 19.5958 24.2376 12.9808 24.2376Z"
                            fill="white"
                          />
                          <path
                            d="M9.90304 10.0059H7.31738V18.0443H9.90304V10.0059Z"
                            fill="white"
                          />
                          <path
                            d="M8.59695 5.98682C7.75038 5.98682 7.06787 6.65036 7.06787 7.4719C7.06787 8.29344 7.75038 8.95699 8.59695 8.95699C9.44352 8.95699 10.126 8.29344 10.126 7.4719C10.126 6.65036 9.44352 5.98682 8.59695 5.98682Z"
                            fill="white"
                          />
                          <path
                            d="M16.5508 9.75977C14.7789 9.75977 14.0373 11.0869 14.0373 11.0869V10.0062H11.5566V18.0447H14.0373C14.0373 18.0447 14.0373 15.0618 14.0373 13.8232C14.0373 12.692 14.5754 12.0222 15.6123 12.0222C16.5639 12.0222 17.0167 12.6667 17.0167 13.8232C17.0167 14.9797 17.0167 18.0447 17.0167 18.0447H19.5892C19.5892 18.0447 19.5892 15.1061 19.5892 12.9511C19.5892 10.8025 18.3227 9.75977 16.5508 9.75977Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_41_189">
                            <rect
                              width="25.9615"
                              height="25"
                              fill="white"
                              transform="translate(0 0.185547)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li data-aos="fade-down" data-aos-delay="300">
                    <a href="https://twitter.com/okc_uptown" target="_blank">
                      <svg
                        width="25"
                        height="26"
                        viewBox="0 0 25 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_41_185)">
                          <path
                            d="M12.5 0.185547C5.60541 0.185547 0 5.79096 0 12.6855C0 19.5801 5.60541 25.1855 12.5 25.1855C19.3946 25.1855 25 19.5801 25 12.6855C25 5.79096 19.3946 0.185547 12.5 0.185547ZM12.5 24.2376C6.12993 24.2376 0.947927 19.0556 0.947927 12.6855C0.947927 6.31548 6.12993 1.13347 12.5 1.13347C18.8701 1.13347 24.0521 6.31548 24.0521 12.6855C24.0521 19.0556 18.8701 24.2376 12.5 24.2376Z"
                            fill="white"
                          />
                          <path
                            d="M18.5541 7.6681C18.0486 7.97144 17.4861 8.1863 16.8858 8.30637C16.4055 7.79449 15.723 7.47852 14.9646 7.47852C13.2647 7.47852 12.0197 9.06471 12.4052 10.7078C10.2187 10.6004 8.28491 9.55132 6.98309 7.9588C6.29427 9.14055 6.62288 10.6888 7.79831 11.4724C7.36858 11.4598 6.96413 11.3397 6.60392 11.1438C6.57864 12.3635 7.45074 13.501 8.71464 13.7538C8.34179 13.8549 7.93734 13.8802 7.52657 13.798C7.8615 14.8408 8.83471 15.6054 9.98486 15.6244C8.87895 16.4901 7.48865 16.8756 6.09204 16.7113C7.25483 17.457 8.6388 17.8931 10.1239 17.8931C15.0026 17.8931 17.7642 13.7728 17.5999 10.0695C18.1118 9.69667 18.5604 9.23534 18.9143 8.71082C18.4404 8.91936 17.9348 9.05839 17.404 9.12159C17.9411 8.79929 18.3582 8.28741 18.5541 7.6681Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_41_185">
                            <rect
                              width="25"
                              height="25"
                              fill="white"
                              transform="translate(0 0.185547)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                  <li data-aos="fade-down" data-aos-delay="400">
                    <a
                      href="https://www.facebook.com/okcuptowncleaning"
                      target="_blank"
                    >
                      <svg
                        width="27"
                        height="26"
                        viewBox="0 0 27 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_41_181)">
                          <path
                            d="M13.1351 0.185547C5.9753 0.185547 0.154297 5.79096 0.154297 12.6855C0.154297 19.5801 5.9753 25.1855 13.1351 25.1855C20.2948 25.1855 26.1158 19.5801 26.1158 12.6855C26.1158 5.79096 20.2948 0.185547 13.1351 0.185547ZM13.1351 24.2376C6.51999 24.2376 1.13868 19.0556 1.13868 12.6855C1.13868 6.31548 6.51999 1.13347 13.1351 1.13347C19.7501 1.13347 25.1314 6.31548 25.1314 12.6855C25.1314 19.0556 19.7501 24.2376 13.1351 24.2376Z"
                            fill="white"
                          />
                          <path
                            d="M11.232 8.21119C11.232 9.81003 11.232 10.1702 11.232 10.1702H9.65039V12.6538H11.232V19.9529H14.2704V12.6222H16.3902L16.6133 10.1702H14.2639C14.2639 10.1702 14.2639 9.25391 14.2639 8.77363C14.2639 8.19224 14.382 7.96473 14.9661 7.96473C15.432 7.96473 16.6133 7.96473 16.6133 7.96473V5.41797C16.6133 5.41797 14.8808 5.41797 14.5067 5.41797C12.2492 5.41797 11.232 6.37853 11.232 8.21119Z"
                            fill="white"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_41_181">
                            <rect
                              width="25.9615"
                              height="25"
                              fill="white"
                              transform="translate(0.154297 0.185547)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <hr style={{ borderColor: "white" }} />
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 mid-footer">
              <div className="awards">
                <img src={require("../../Assets/img/award1.png")} alt="" />
                <img src={require("../../Assets/img/award2.png")} alt="" />
              </div>
              <div className="footerInfo">
                <div className="footerInfo-inner">
                  <span>
                    Address
                    <br />
                    <a
                      target="_blank"
                      href="https://www.google.com/maps/place/2809+Greenfield+Dr,+Edmond,+OK+73012,+USA/@35.6411536,-97.5207265,17z/data=!3m1!4b1!4m6!3m5!1s0x87b21e7ec0893f11:0x84225b4a12571f3c!8m2!3d35.6411536!4d-97.5207265!16s%2Fg%2F11c2hg_lw5?entry=ttu"
                    >
                      2809 Greenfield Dr. Edmond, Oklahoma 73012
                    </a>
                  </span>
                </div>
                <div className="footerInfo-inner">
                  <span>
                    Phone Number
                    <br />
                    <a href="tel:405-882-2863">405-882-2863</a>
                  </span>
                </div>
                <div className="footerInfo-inner">
                  <span>
                    Email Address
                    <br />
                    <a href="mailto:okcuptowncleaning@gmail.com">
                      okcuptowncleaning@gmail.com
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
                <span>
                  © 2023 Landing pr. All Rights Reserved. Designed by{" "}
                  <a
                    href="http://techxerro.com"
                    style={{ fontWeight: "600", color: "#efefef" }}
                  >
                    Techxerro
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
